import Firebase, { Promise } from 'firebase'
let config = {
  apiKey: 'AIzaSyB8-MwZUjJFfkgJVExYxQ_f_uThHFjlzeg',
  authDomain: 'arrowcerts.firebaseapp.com',
  databaseURL: 'https://arrowcerts.firebaseio.com',
  projectId: 'arrowcerts',
  storageBucket: 'gs://arrowcerts.appspot.com',
  messagingSenderId: '855821689425'
}

let firebaseApp = Firebase.initializeApp(config)
let firebaseDb = firebaseApp.database()
let firebaseStorage = firebaseApp.storage()

let tenant = {}

tenant.initialize = () => {
  return new Promise((resolve, reject) => {
    if (process.env.NODE_ENV === 'development') {
      tenant.name = 'arrowig'
      return firebaseApp.auth().onAuthStateChanged((user) => {
        if (user) {
          tenant.user = user
          resolve()
        }
      })
    } else {
      // try to get it from session storage
      let tenantName = window.sessionStorage.getItem('tenantName')
      if (tenantName) {
        tenant.name = tenantName
        resolve()
      }

      // get the user
      return firebaseApp.auth().onAuthStateChanged((user) => {
        if (user) {
          tenant.user = user

          // if we didn't get tenant name from storage, then get it from the user's default tenant in firebase
          if (!tenant.name) {
            let convertedEmail = user.email.toLowerCase().replace(/\./g, '%2E')
            return firebaseDb.ref('users/' + convertedEmail).once('value').then(snapshot => {
              // set it in session storage for next time
              if (snapshot.val()) {
                window.sessionStorage.setItem('tenantName', snapshot.val())
                tenant.name = snapshot.val()
              }
              resolve()
            })
          }
        } else {
          tenant.user = null
          resolve()
        }
      })
    }
  })
}

tenant.firebaseDb = firebaseDb
tenant.firebaseStorage = firebaseStorage

tenant.ref = refName => {
  return firebaseDb.ref('agencies/' + tenant.name + '/' + refName)
}
tenant.agencyRef = () => {
  return firebaseDb.ref('agencies/' + tenant.name)
}

tenant.getArray = obj => {
  let arr = []
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      let arrayItem = obj[key]
      arrayItem.key = key
      arr.push(arrayItem)
    }
  }
  return arr
}

tenant.app = firebaseApp

export default tenant



// WEBPACK FOOTER //
// ./src/tenant.js